import { ContrastSlider } from '../ContrastSlider';
type ContrastControlsProps = {
  disabled: boolean;
};

export const ContrastControls = ({ disabled }: ContrastControlsProps) => {
  return <ContrastSlider title="Contrast level" disabled={disabled} step={1} min={0} max={100} />;
};
